import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Inbox, MapPin, Check, BadgePercent } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const StudyRequests = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/study-requests").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const handle = async (id) => {
    try { await api.put(`/study-requests/${id}`, { status: "handled" }); setItems((l) => l.filter((x) => x.id !== id)); toast.success("Marked as handled"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!items.length) return null;
  return (
    <section className="rounded-xl border border-cyan-500/30 bg-cyan-500/5 p-6 mb-8 space-y-3" data-testid="study-requests">
      <h2 className="flex items-center gap-2 font-display text-lg font-semibold text-cyan-300"><Inbox className="h-5 w-5" />New study requests from clients <span className="num text-sm px-2 rounded-full bg-cyan-500/20">{items.length}</span></h2>
      {items.map((r) => (
        <div key={r.id} className="rounded-lg border border-slate-800 bg-slate-950/50 p-4 flex flex-wrap items-start gap-4" data-testid={`study-request-${r.id}`}>
          <div className="flex-1 min-w-[240px] space-y-1">
            <p className="font-semibold">{r.project_name} <span className="text-sm font-normal text-slate-400">· {r.client_name}{r.client_company ? `, ${r.client_company}` : ""}</span></p>
            {r.address && <p className="flex items-center gap-1 text-xs text-cyan-300"><MapPin className="h-3 w-3" />{r.address}</p>}
            <p className="text-sm text-slate-400">{r.description}</p>
            {r.offer_percent && <p className="flex items-center gap-1 text-xs text-amber-300"><BadgePercent className="h-3.5 w-3.5" />{r.offer_percent}% repeat-client discount applies to their next invoice</p>}
          </div>
          <Button data-testid={`study-request-handled-${r.id}`} size="sm" variant="outline" onClick={() => handle(r.id)} className="rounded-full border-slate-700 bg-transparent"><Check className="h-4 w-4 mr-1" />Mark handled</Button>
        </div>
      ))}
    </section>
  );
};
